import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/order/importer/orderImporterActions';

export default importerReducers(actions);
